import { createSlice } from "@reduxjs/toolkit";

const spacesDOSettingsState = {
  spacesDOSettings: {},
  spacesDOSettingsLoading: false,
};

const reducers = {
  spacesDOSettingsLoading(state) {
    if (!state.spacesDOSettingsLoading) {
      state.spacesDOSettingsLoading = true;
    }
  },
  spacesDOSettingsReceived(state, action) {
    if (state.spacesDOSettingsLoading) {
      state.spacesDOSettingsLoading = false;
      state.spacesDOSettings = action.payload;
    }
  },
};

export const slice = createSlice({
  name: "spaces-do-settings",
  initialState: spacesDOSettingsState,
  reducers,
});

export const { reducer } = slice;
